import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "cursor-pointer group"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "nk-breadcrumb-item__toggler",
  width: "19",
  height: "18",
  viewBox: "0 0 19 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.75 9C0.75 4.17 4.67 0.25 9.5 0.25C14.33 0.25 18.25 4.17 18.25 9C18.25 13.83 14.33 17.75 9.5 17.75C4.67 17.75 0.75 13.83 0.75 9ZM6.7525 8.8775L9.19375 11.3188C9.36 11.485 9.64 11.485 9.815 11.31L12.2562 8.86875C12.5362 8.5975 12.3438 8.125 11.95 8.125H7.05875C6.665 8.125 6.4725 8.5975 6.7525 8.8775Z",
    fill: "#FF6D10"
  })
], -1)
const _hoisted_3 = { class: "nk-popper-item-wrapper" }
const _hoisted_4 = {
  key: 1,
  class: "nk-popper-item group block"
}

import { ref } from 'vue';
import { NkText, NkPopper } from '@/core/components';
import { StBreadcrumbItem } from './breadcrumb-item.styled';
import { props as propsDefinition } from './breadcrumb-item.shared';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkBreadcrumbItem',
  props: propsDefinition,
  setup(__props) {

const props = __props



const isPopperOpen = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(StBreadcrumbItem), {
    class: _normalizeClass(["nk-breadcrumb-item", {'is-open': isPopperOpen.value}])
  }, {
    default: _withCtx(() => [
      (props.link.to)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: props.link.to,
            class: "cursor-pointer group"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkText), {
                class: "group-hover:text-primary transition-colors",
                type: "bold",
                uppercase: "",
                as: "span"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.link.name), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"]))
        : (_openBlock(), _createElementBlock("span", _hoisted_1, [
            _createVNode(_unref(NkText), {
              class: "group-hover:text-primary transition-colors",
              type: "bold",
              uppercase: "",
              as: "span"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.link.name), 1)
              ]),
              _: 1
            })
          ])),
      (props.link.sublinks && props.link.sublinks.length)
        ? (_openBlock(), _createBlock(_unref(NkPopper), {
            key: 2,
            styled: "",
            "onOpen:popper": _cache[0] || (_cache[0] = ($event: any) => (isPopperOpen.value = true)),
            "onClose:popper": _cache[1] || (_cache[1] = ($event: any) => (isPopperOpen.value = false))
          }, {
            reference: _withCtx(() => [
              _hoisted_2
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.link.sublinks, (sublink) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: sublink.name
                  }, [
                    (sublink.to)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: sublink.to,
                          class: "nk-popper-item group block"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NkText), {
                              class: "group-hover:text-primary transition-colors",
                              type: "bold",
                              uppercase: "",
                              as: "span"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(sublink.name), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_4, [
                          _createVNode(_unref(NkText), {
                            class: "group-hover:text-primary transition-colors",
                            type: "bold",
                            uppercase: "",
                            as: "span"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(sublink.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                  ], 64))
                }), 128))
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})